import axios from 'axios';
import OSS from 'ali-oss';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * 将生产的aliyun的url转换成正式的url
 * @param url
 * @returns
 */
function formatOssUrl(url) {
    // 将opyx-mtds-pro.oss-cn-shenzhen.aliyuncs.com都替换成mtdsosscdn.oppein.com
    return url.replace(/opyx-mtds-pro.oss-cn-shenzhen.aliyuncs.com/gi, 'mtdsosscdn.oppein.com');
}
// ssr support
var inBrowser = typeof window !== 'undefined';
// export const isServer = Vue.prototype.$isServer
var ua = (inBrowser && navigator.userAgent.toLowerCase()) || '';
var _ua = (inBrowser && navigator.userAgent) || '';
var regMiniprogram = ua.match(/miniprogram/i);
var isMiniProgram = function () {
    return regMiniprogram && regMiniprogram[0] == 'miniprogram';
};

if (isMiniProgram()) ;

var handleRespone = Symbol('handleRespone');
var AuthType;
(function (AuthType) {
    AuthType[AuthType["PUBLIC"] = 0] = "PUBLIC";
    AuthType[AuthType["WRITE"] = 1] = "WRITE";
    AuthType[AuthType["READ"] = 2] = "READ";
})(AuthType || (AuthType = {}));
var Axios = /** @class */ (function () {
    function Axios(options) {
        this.ossSignature = '/attachment/attachment/ossSignature'; // 公有直传获取令牌接口
        this.ossToken = '/attachment/attachment/ossToken';
        this.ossPrivateTokenW = '/attachment/attachment/ossToken/private/w';
        this.ossPrivateTokenR = '/attachment/attachment/ossToken/private/r';
        this.unifiedNumbering = '/unified-numbering/global/id';
        this.uploadType = 'SDK';
        var baseURL = options.baseURL, token = options.token, appCode = options.appCode, subAppCode = options.subAppCode;
        this.baseURL = baseURL;
        this.token = token;
        this.appCode = appCode;
        this.subAppCode = subAppCode;
        this.uploadType = options.uploadType || 'SDK';
    }
    Axios.prototype.setBaseURL = function (baseURL) {
        this.baseURL = baseURL;
    };
    Axios.prototype.setToken = function (token) {
        this.token = token;
    };
    Axios.prototype.__get = function (url) {
        if (!this.token)
            return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return axios.get(url, {
            baseURL: this.baseURL,
            headers: {
                'Oauth2-AccessToken': this.token,
                SubAppCode: this.subAppCode,
                AppCode: this.appCode
            }
        });
    };
    Axios.prototype._getTokenUrl = function (type) {
        switch (type) {
            case AuthType.WRITE:
                return this.ossPrivateTokenW;
            case AuthType.READ:
                return this.ossPrivateTokenR;
            case AuthType.PUBLIC:
            default:
                return this.uploadType === 'SDK' ? this.ossToken : this.ossSignature;
        }
    };
    // 获取临时令牌和配置信息
    Axios.prototype.getOSSToken = function (authType) {
        var _this = this;
        var _a;
        var url = this._getTokenUrl(authType);
        return (_a = this.__get(url)) === null || _a === void 0 ? void 0 : _a.then(function (r) {
            var res = _this[handleRespone](r);
            return res.data;
        })["catch"](function (e) { return e.data; });
    };
    // 生成唯一ID
    Axios.prototype.getUnifiedNumbering = function () {
        var _this = this;
        var _a;
        return (_a = this.__get(this.unifiedNumbering)) === null || _a === void 0 ? void 0 : _a.then(function (r) {
            var res = _this[handleRespone](r);
            return res.data;
        })["catch"](function (e) { return e.data; });
    };
    // 处理返回体
    Axios.prototype[handleRespone] = function (res) {
        if (res.data.code !== '100000') {
            // TODO: 考虑是否对接统一授权页面
            console.error(res.data);
        }
        return res;
    };
    return Axios;
}());

var isExtInfoType = function (extInfo) {
    return Object.keys(extInfo).includes('sysPlatform') && Object.keys(extInfo).includes('businessType');
};
var OssUpload = /** @class */ (function (_super) {
    __extends(OssUpload, _super);
    function OssUpload(options) {
        var _this = this;
        var time = options.time, axiosOptions = __rest(options, ["time"]);
        _this = _super.call(this, axiosOptions) || this;
        _this.time = time || 36000; // 默认缓存10分钟
        return _this;
    }
    /**
     * @description 实例化OSS SDK
     * @param ossOption <OssOptions>
     * @param authType <AuthType>   公有：PUBLIC = 0, 私有上传：WRITE = 1, 私有查看：READ = 2
     * @return OSS instance
     * */
    OssUpload.prototype.instantiateOSS = function (ossOption, authType) {
        if (authType === void 0) { authType = AuthType.PUBLIC; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, status_1, message;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.ossOption || this.ossOption.expiration - new Date().getTime() < this.time || authType === AuthType.READ)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getOSSToken(authType)];
                    case 1:
                        _a = _b.sent(), data = _a.data, status_1 = _a.status, message = _a.message;
                        if (!status_1) {
                            return [2 /*return*/, new Error('实例化OSS失败！' + message ? message : '')];
                        }
                        this.ossOption = {
                            endpoint: data.endpoint.replace(/^http:/, 'https:'),
                            bucket: data.bucket,
                            secure: true,
                            stsToken: data.securityToken,
                            accessKeyId: data.appKey,
                            accessKeySecret: data.appSecret,
                            expiration: data.expiration
                        };
                        // 获取签名URL需要强制刷新令牌、bucket，并且直接返回实例
                        if (authType === AuthType.READ) {
                            return [2 /*return*/, new OSS(this.ossOption)];
                        }
                        _b.label = 2;
                    case 2:
                        if (!this.__OSS) {
                            this.__OSS = new OSS(ossOption || this.ossOption);
                        }
                        return [2 /*return*/, this.__OSS];
                }
            });
        });
    };
    /**
     * @description 获取保存文件路径，根据业务参数拼接文件存放目录
     * @param origFileName <string> 原文件名，
     * @param extInfo <object> 业务系统描述目录参数， 示例{businessType: 'Public', sysPlatform: 'MTDS'}
     * @return path <string> 文件存放目录绝对路径
     * */
    OssUpload.prototype.getFilePath = function (origFileName, extInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var path, extInfoKey, resp, suffixArr, suffix;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!extInfo) {
                            throw new Error("缺少业务参数作为文件存放目录依据，参考例如：{businessType: 'Public', sysPlatform: 'MTDS'}");
                        }
                        path = '';
                        if (isExtInfoType(extInfo)) {
                            if (!extInfo.sysPlatform) {
                                throw new Error('缺少业务参数：sysPlatform');
                            }
                            if (!extInfo.businessType) {
                                throw new Error('缺少业务参数：businessType');
                            }
                            path = "".concat(extInfo.sysPlatform, "/").concat(extInfo.businessType);
                        }
                        else if (typeof extInfo === 'object' && Object.keys(extInfo).length) {
                            for (extInfoKey in extInfo) {
                                path += "".concat(extInfo[extInfoKey], "/");
                            }
                        }
                        else if (typeof extInfo === 'string') {
                            path = extInfo;
                        }
                        else {
                            throw new Error("暂时不支持此类型参数，参考例如：{businessType: 'Public', sysPlatform: 'MTDS'}");
                        }
                        return [4 /*yield*/, this.getUnifiedNumbering()];
                    case 1:
                        resp = _a.sent();
                        if (!resp || !resp.data || !resp.status) {
                            throw new Error('获取唯一id失败');
                        }
                        suffixArr = origFileName.split('.');
                        suffix = suffixArr[suffixArr.length - 1];
                        return [2 /*return*/, "".concat(path, "/").concat(resp.data, ".").concat(suffix)];
                }
            });
        });
    };
    /**
     * @description 获取签名图片url, 获取图片默认为私有可读令牌，
     * @param path<string>
     * @param option <SignatureUrlOption> {
     *    expires: <number> 过期时间，默认1800s
     *    process: <string> 图片处理参数
     *   }
     * @return url <string>
     * */
    OssUpload.prototype.getSignatureUrl = function (path, option) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var instance, url, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.instantiateOSS(undefined, AuthType.READ)];
                    case 1:
                        instance = _a.sent();
                        url = instance.signatureUrl(path, option);
                        resolve(url);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        reject({ status: false, message: '获取！', error: error_1 });
                        console.error('error: %j', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    // Buffer
    OssUpload.prototype.putBuffer = function (fileBuffer, extInfo, authType, signatureUrlOption) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var instance, filePath, resp, result, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, this.instantiateOSS(this.ossOption, authType)
                            // 通过业务参数拼接文件路径，业务参数必须
                        ];
                    case 1:
                        instance = _b.sent();
                        return [4 /*yield*/, this.getFilePath(fileBuffer.name, extInfo)
                            // 开始简单上传
                        ];
                    case 2:
                        filePath = _b.sent();
                        return [4 /*yield*/, instance.put(filePath, fileBuffer.file)];
                    case 3:
                        resp = _b.sent();
                        if (!(resp.res.status === 200 && resp.res.statusCode === 200)) return [3 /*break*/, 6];
                        result = resp;
                        if (!(authType === AuthType.WRITE)) return [3 /*break*/, 5];
                        _a = result;
                        return [4 /*yield*/, this.getSignatureUrl(result.name, signatureUrlOption)];
                    case 4:
                        _a.signatureUrl = _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/, resolve(result)];
                    case 6:
                        reject({ status: false, message: '上传失败！' });
                        return [3 /*break*/, 8];
                    case 7:
                        error_2 = _b.sent();
                        reject({ status: false, message: '上传失败！', error: error_2 });
                        console.error('error: %j', error_2);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * @name uploadFile
     * @description 简单上传
     * @param fileRaw<any> 文件流对象，
     * @param extInfo<ExtInfo|object|string> 业务系统描述目录参数， 示例{businessType: 'Public', sysPlatform: 'MTDS'}
     * @param authType<AuthType>   公有：PUBLIC = 0, 私有上传：WRITE = 1, 私有查看：READ = 2
     * @param signatureUrlOption <SignatureUrlOption> {
     *    expires: <number> 过期时间，默认1800s
     *    process: <string> 图片处理参数
     *   }
     * @return response <AxiosResponse> 上传结果，如果是私有文件，signatureUrl则非null
     * */
    // 简单上传
    OssUpload.prototype.uploadFile = function (fileRaw, extInfo, authType, signatureUrlOption) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // console.warn(extInfo, authType, signatureUrlOption)
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var filePath, resp, result, _a, error_3;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _b.trys.push([0, 7, , 8]);
                                    // 通过临时令牌实例化OSS
                                    return [4 /*yield*/, this.instantiateOSS(this.ossOption, authType)
                                        // 通过业务参数拼接文件路径，业务参数必须
                                    ];
                                case 1:
                                    // 通过临时令牌实例化OSS
                                    _b.sent();
                                    return [4 /*yield*/, this.getFilePath(fileRaw.file.name, extInfo)
                                        // 开始简单上传
                                    ];
                                case 2:
                                    filePath = _b.sent();
                                    return [4 /*yield*/, this.__OSS.put(filePath, fileRaw.file)];
                                case 3:
                                    resp = _b.sent();
                                    if (!(resp.res.status === 200 && resp.res.statusCode === 200)) return [3 /*break*/, 6];
                                    result = this.formattingResult(fileRaw, resp);
                                    if (!(authType === AuthType.WRITE)) return [3 /*break*/, 5];
                                    _a = result;
                                    return [4 /*yield*/, this.getSignatureUrl(result.name, signatureUrlOption)];
                                case 4:
                                    _a.signatureUrl = _b.sent();
                                    _b.label = 5;
                                case 5: return [2 /*return*/, resolve(result)];
                                case 6:
                                    reject({ status: false, message: '上传失败！' });
                                    return [3 /*break*/, 8];
                                case 7:
                                    error_3 = _b.sent();
                                    reject({ status: false, message: '上传失败！', error: error_3 });
                                    console.error('error: %j', error_3);
                                    return [3 /*break*/, 8];
                                case 8: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    // 分片上传
    OssUpload.prototype.multipartUpload = function (fileRaw, extInfo, cb, checkpointId, authType, signatureUrlOption) {
        if (authType === void 0) { authType = AuthType.PUBLIC; }
        return __awaiter(this, void 0, void 0, function () {
            var filePath, _checkpointId, checkpointStr, multipartUploadResult, instance, resp, result, _a, e_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getFilePath(fileRaw.file.name, extInfo)
                        // TODO: checkPointId需要优化，要考虑是否用md5确定唯一性
                    ];
                    case 1:
                        filePath = _b.sent();
                        _checkpointId = checkpointId || 'checkpoint_' + filePath.replace(/\//gi, '_');
                        checkpointStr = window.localStorage.getItem(_checkpointId);
                        multipartUploadResult = {
                            partSize: 102400 * 5,
                            parallel: 8,
                            progress: function (p, cpt) {
                                if (!cpt) {
                                    return;
                                }
                                // 断点记录点。浏览器重启后无法直接继续上传，您需要手动触发上传操作。
                                if (cpt) {
                                    window.localStorage.setItem(_checkpointId, JSON.stringify(cpt));
                                }
                                var fileInfo = _this.formattingResult(fileRaw);
                                var checkpointFileInfo = Object.assign(fileInfo, {
                                    uploadId: cpt ? cpt.uploadId : '',
                                    checkpointId: _checkpointId,
                                    percentage: p,
                                    name: filePath
                                });
                                if (cb) {
                                    cb(checkpointFileInfo);
                                }
                            }
                        };
                        if (checkpointStr) {
                            multipartUploadResult = Object.assign(multipartUploadResult, { checkpoint: JSON.parse(checkpointStr) });
                        }
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, , 8]);
                        return [4 /*yield*/, this.instantiateOSS(this.ossOption, authType)];
                    case 3:
                        instance = _b.sent();
                        return [4 /*yield*/, instance.multipartUpload(filePath, fileRaw.file, multipartUploadResult)];
                    case 4:
                        resp = _b.sent();
                        result = this.formattingResult(fileRaw, resp);
                        if (!(authType === AuthType.WRITE)) return [3 /*break*/, 6];
                        _a = result;
                        return [4 /*yield*/, this.getSignatureUrl(result.name, signatureUrlOption)];
                    case 5:
                        _a.signatureUrl = _b.sent();
                        _b.label = 6;
                    case 6:
                        window.localStorage.removeItem(_checkpointId);
                        return [2 /*return*/, result];
                    case 7:
                        e_1 = _b.sent();
                        // TODO
                        console.error(e_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    // 暂停分片上传
    OssUpload.prototype.formattingResult = function (fileRaw, resp) {
        var baseInfo = {
            status: false,
            uid: fileRaw.file.uid,
            file: fileRaw,
            filename: fileRaw.file.name,
            size: fileRaw.file.size,
            signatureUrl: null
        };
        if (resp) {
            var suffixArr = resp.name.split('.');
            var suffix = suffixArr[suffixArr.length - 1];
            return Object.assign(baseInfo, {
                status: true,
                name: resp.name,
                url: resp.res.requestUrls[0].split('?')[0],
                suffix: suffix
            });
        }
        return baseInfo;
    };
    /**
     * @description 获取签名图片url, 获取图片默认为私有可读令牌，
     * @param name<string> osskey
     * @param fileName<string> 下载后的文件名
     * @param authType<number> 下载文件类型：0 公有文件，1 私有文件
     * @return 浏览器下载
     * */
    OssUpload.prototype.downloadPath = function (name, fileName, authType) {
        if (authType === void 0) { authType = AuthType.PUBLIC; }
        return __awaiter(this, void 0, void 0, function () {
            var _path, ossOption, _authType, _instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _path = name.replace(/\+/gi, '%20');
                        ossOption = authType === AuthType.WRITE ? undefined : this.ossOption;
                        _authType = authType === AuthType.WRITE ? AuthType.READ : AuthType.PUBLIC;
                        return [4 /*yield*/, this.instantiateOSS(ossOption, _authType)];
                    case 1:
                        _instance = _a.sent();
                        return [2 /*return*/, _instance.signatureUrl(decodeURIComponent(_path), {
                                expires: 3600,
                                response: {
                                    'content-disposition': 'attachment; filename="' + fileName + '"'
                                }
                            })];
                }
            });
        });
    };
    return OssUpload;
}(Axios));

var UniUploadFile = /** @class */ (function (_super) {
    __extends(UniUploadFile, _super);
    function UniUploadFile(options) {
        return _super.call(this, options) || this;
    }
    UniUploadFile.prototype.uploadFile = function (file, business, header) {
        if (header === void 0) { header = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var ossTokenInfo, _unifiedNumbering, formData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!business) {
                            throw Error('确实文件所属模块参数：business');
                        }
                        return [4 /*yield*/, this.getOSSToken(0)];
                    case 1:
                        ossTokenInfo = (_a.sent()).data;
                        return [4 /*yield*/, this.getUnifiedNumbering()];
                    case 2:
                        _unifiedNumbering = (_a.sent()).data;
                        if (!ossTokenInfo)
                            return [2 /*return*/];
                        formData = {
                            key: "".concat(this.appCode, "/").concat(this.subAppCode, "/").concat(business, "/").concat(_unifiedNumbering || new Date().valueOf(), ".").concat((typeof file === 'string' ? file : file.name).split('.')[1]),
                            ossAccessKeyId: ossTokenInfo.appKey,
                            signature: ossTokenInfo.signature,
                            policy: ossTokenInfo.policy,
                            'x-oss-security-token': ossTokenInfo.securityToken
                        };
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                uni.uploadFile({
                                    url: ossTokenInfo.host,
                                    filePath: typeof file === 'string' ? file : file.url,
                                    name: 'file',
                                    formData: formData,
                                    header: header,
                                    success: function (res) {
                                        if (res && res.errMsg === 'uploadFile:ok') {
                                            resolve({
                                                ossKey: formData.key,
                                                url: ossTokenInfo.host + '/' + formData.key,
                                                name: file.name
                                            });
                                        }
                                        resolve(false);
                                    },
                                    fail: function (e) {
                                        reject(false);
                                    }
                                });
                            })];
                }
            });
        });
    };
    return UniUploadFile;
}(Axios));

export { isExtInfoType, OssUpload, formatOssUrl, inBrowser, ua, isMiniProgram, UniUploadFile };
//# sourceMappingURL=op-upload.es5.js.map
